var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--mypage"
  }, [_c('v-container', [_c('div', {
    staticClass: "mypage-container"
  }, [_c('mypage-navigation'), _c('div', {
    staticClass: "mypage-contents"
  }, [_c('div', {
    staticClass: "tit-wrap mb-12 mb-md-16"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.title))])]), _c('div', {
    staticClass: "tab-wrap"
  }, [_c('v-tabs', {
    staticClass: "tab tab--block",
    attrs: {
      "hide-slider": ""
    }
  }, _vm._l(_vm.auctionHalls, function (_ref) {
    var value = _ref.value,
        text = _ref.text;
    return _c('v-tab', {
      key: value,
      attrs: {
        "to": "/mypage/bids-".concat(_vm.type, "/").concat(value)
      }
    }, [_vm._v(_vm._s(text))]);
  }), 1), _c('v-divider', {
    staticClass: "primary border-3"
  })], 1), _c('v-tabs-items', {
    attrs: {
      "value": _vm.tab
    }
  }, _vm._l(_vm.auctionHalls, function (_ref2) {
    var value = _ref2.value;
    return _c('bids-list', {
      key: value,
      attrs: {
        "hall": value
      }
    });
  }), 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }